import { defineActions } from './defineActions'

/** Case status in the page header. Action names start with CaseStatus. */
export const caseStatusActions = defineActions({
  'CaseStatus.Override': {
    label: 'Change case status',
    area: 'Case status',
    description:
      'A status chip in the Case Progress panel clicked and confirmed (status override by Admin Staff / Staff).',
  },
})
